import React from 'react'
import {GoogleApiWrapper} from 'google-maps-react'
//pass the google info as props to the Map

import Map from './Map'

class MapWrapper extends React.Component {

    shouldComponentUpdate(){
        return true;
    }

    render(){

        return (
            <Map google={this.props.google} samples={this.props.samples} summary={this.props.summary} coordinates={this.props.coordinates}/>
        )
    }
}

export default GoogleApiWrapper({
    apiKey: "AIzaSyDMLlFRjTwgltbFHU1O1f6eVr78ltAn8LM",
    libraries: ['visualization']
})(MapWrapper)